import Splash from '../../app/Pages/Splash';

export const SplashRouteConfig = [
  {
    path: '',
    element: <Splash />,
  },
];
